import React, { useEffect } from "react";
import "./modal.scss";
import cross from "../../../Assets/Images/close-button.svg";
import { useHistory } from "react-router-dom";

interface IModalProps {
  children?: React.ReactNode;
  isOpen: boolean;
  onExitClicked: () => void;
  heading?: string | undefined;
  subHeading?: string | undefined;
  summaryText?: string | undefined;
  centerAlignedModal?: boolean;
  showCloseButton?: boolean;
  modalContainerClassName?: string;
  modalBodyContainerClassName?: string;
  modalContainerOverlay?: string;
  overlay?: boolean;
  backKeyToCloseModal?: boolean;
  onModalOpenHandler?: () => void;
  windowBackHandler?: () => void;
}

const Modal = ({
  children,
  isOpen,
  onExitClicked,
  heading,
  summaryText,
  centerAlignedModal,
  showCloseButton,
  modalContainerClassName,
  modalBodyContainerClassName,
  modalContainerOverlay,
  overlay = true,
  backKeyToCloseModal = false,
  onModalOpenHandler,
  windowBackHandler
}: IModalProps) => {

  const history = useHistory();

  useEffect(()=>{
    if(onModalOpenHandler){
      onModalOpenHandler()
    }
    if(isOpen && backKeyToCloseModal){ 
      history.push(history.location);
    }
},[isOpen])

  useEffect(() => {
    window.onpopstate = (event) => {
      event.preventDefault();
    };
    if(history.action === "POP") {
      if(backKeyToCloseModal && windowBackHandler) {
        windowBackHandler();
      }
    }
    return () => {
      window.onpopstate = null;
    }
  }, [history.location]);

  return (
    <div>
      {isOpen ? (
        <div
          className={
            modalContainerOverlay
              ? modalContainerOverlay
              : overlay
              ? "modal-component-overlay"
              : ""
          }
          onClick={onExitClicked}
        ></div>
      ) : null}
      <div
        className={
          modalContainerClassName
            ? modalContainerClassName
            : centerAlignedModal
            ? "plain-modal-component"
            : "modal-component"
        }
        style={{ display: isOpen ? "" : "none" }}
      >
        {(heading || summaryText) && (
          <div className="modal-component-header">
            {typeof heading !== "undefined" && (
              <div className="modal-component-heading">{heading}</div>
            )}
            {typeof summaryText !== "undefined" && (
              <div className="modal-component-summary">{summaryText}</div>
            )}
          </div>
        )}
        {showCloseButton && (
          <div onClick={onExitClicked} className="modal-button-div">
            <img src={cross} alt="" className="modal-close-button" />
          </div>
        )}
        <div
          className={
            modalBodyContainerClassName
              ? modalBodyContainerClassName
              : centerAlignedModal
              ? "plain-modal-component-body"
              : "modal-component-body"
          }
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
